import { render, staticRenderFns } from "./SignatureDash.vue?vue&type=template&id=6427823c&scoped=true"
import script from "./SignatureDash.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SignatureDash.vue?vue&type=style&index=0&id=6427823c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427823c",
  null
  
)

export default component.exports